import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Cart} from '@spartacus/cart/base/root';
import {B2BUser, Occ, User} from '@spartacus/core';
import {Observable} from 'rxjs';
import {first, take} from 'rxjs/operators';
import {B2bUnitService} from '@app/services/b2b-unit.service';
import {DcpUserService} from '@app/services/user/dcp-user.service';
import {AddressUsage} from '@app/model/order/dcp-order-entry.model';
import {DcpActiveCartService} from '@app/services/dcp-active-cart.service';
import {PermissionService} from '@app/services/permission/permission.service';

@UntilDestroy()
@Component({
  selector: 'dcp-buyer-details',
  templateUrl: './buyer-details.component.html',
})
export class BuyerDetailsComponent implements OnInit {
  isTechnicalContactCheckboxChecked: boolean;
  isCurrentUserIndividual: boolean;
  contacts: B2BUser[];

  @Input() currentUser: User;
  @Input() b2bUnitContacts$: Observable<B2BUser[]>;

  initialSelectedContact: number = 0;
  contactsLoaded = false;
  allowSelectTechnicalContact = false;
  private currentUserUid: string;
  readonly contactRole = AddressUsage.IT_CONTACT;

  constructor(
    private b2bUnitService: B2bUnitService,
    private dcpUserService: DcpUserService,
    private dcpActiveCartService: DcpActiveCartService,
    private cdr: ChangeDetectorRef,
    private permissionService: PermissionService,
  ) {
  }

  ngOnInit() {
    this.isCurrentUserIndividual = this.dcpUserService.isUserCompanyTypeIndividual(this.currentUser);
    this.currentUserUid = this.currentUser.uid;
    this.b2bUnitService.setCheckoutItContact(this.currentUserUid);
    this.initB2BUnitContacts();
    this.allowSelectTechnicalContact = this.permissionService.hasPermission('contact-creation');
    this.cdr.detectChanges();
  }

  onKeyDown(event): void {
    if (event.target.type !== 'button') {
      this.isTechnicalContactCheckboxChecked = !this.isTechnicalContactCheckboxChecked;
    }
  };

  onChange($event: Event): void {
    const isDeselected = this.isCheckboxDeselected($event.target as HTMLInputElement);
    this.isTechnicalContactCheckboxChecked = !isDeselected;
    if (isDeselected) {
      this.b2bUnitService.setCheckoutItContact(this.currentUserUid);
    } else {
      this.updateB2BUnitContacts();
    }
  }

  isCheckboxDeselected(event: HTMLInputElement): boolean {
    return !event.checked;
  }

  onContactSelect($event: B2BUser): void {
    this.b2bUnitService.setCheckoutItContact($event.uid);
  }

  private initB2BUnitContacts() {
    this.b2bUnitContacts$.pipe(untilDestroyed(this)).subscribe((b2bUnitContacts: B2BUser[]) => {
      this.contacts = b2bUnitContacts.filter((contact: Occ.B2BUser) => contact.uid !== this.currentUserUid);
      if (this.contacts.length) {
        this.dcpActiveCartService.getActiveCart().pipe(take(1), untilDestroyed(this)).subscribe((cart: Cart) => {
          const cartItContact = cart.addresses.find((address) => address.addressUsage === 'IT_CONTACT');
          const previouslySelected = this.contacts.find((contact) => contact.email === cartItContact?.email);
          if (previouslySelected) {
            this.initialSelectedContact = this.contacts.indexOf(previouslySelected);
            this.isTechnicalContactCheckboxChecked = true;
          }
        });
      }
      this.contactsLoaded = true;
      this.cdr.detectChanges();
    });
  }

  private updateB2BUnitContacts() {
    this.b2bUnitContacts$.pipe(first(), untilDestroyed(this))
      .subscribe((b2bUnitContacts: B2BUser[]) => {
        const contactsUids: string[] = this.contacts.map(contact => contact.uid);
        const filteredContacts: B2BUser[] = b2bUnitContacts.filter(contact => !contactsUids.includes(contact.uid)).filter(contact => contact.uid !== this.currentUser.uid);
        this.contacts = this.contacts.concat(filteredContacts);
        this.cdr.detectChanges();
      });
  }
}
